module.exports = __webpack_public_path__ + "media/images/clearview-logo-69d630025929ed72d0bb44d14b2cb34a.svg";